module.exports = __webpack_public_path__ + "static/img/01055A_1_R_20201018_LC.dd10825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01055A_1_R_20201018_LC.png
// module id = ON67
// module chunks = 0